export const VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD = "VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD";
export const VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT = "VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT";
export const VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE = "VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE";
export const VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT = "VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT";
export const VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE = "VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE";

